import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useGoogleLogin } from "@react-oauth/google";
import { FcGoogle } from "react-icons/fc";
import { useAuth } from "../context/AuthContext";
import { googleAuth } from "../api/client";
import ThemeSelector from "../components/ThemeSelector";

export default function Login() {
  const [error, setError] = useState("");
  const [googleLoading, setGoogleLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const googleLogin = useGoogleLogin({
    flow: "implicit",
    onSuccess: async (tokenResponse) => {
      setGoogleLoading(true);
      setError("");
      try {
        const userInfoRes = await fetch("https://www.googleapis.com/oauth2/v3/userinfo", {
          headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
        });
        const userInfo = await userInfoRes.json();

        const res = await googleAuth({
          token: tokenResponse.access_token,
          email: userInfo.email,
          name: userInfo.name,
        });

        login(res.data.access_token, res.data.user);
        navigate("/welcome");
      } catch (err) {
        setError(err.response?.data?.detail || "Google sign-in failed. Please try again.");
      } finally {
        setGoogleLoading(false);
      }
    },
    onError: (err) => {
      console.error("Google login error:", err);
      setError("Google sign-in failed. Please try again.");
    },
  });

  return (
    <div className="login-page">
      <ThemeSelector />

      <motion.div
        className="login-container"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        {/* Logo / Brand */}
        <div className="brand">
          <motion.div
            className="brand-logo"
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
            style={{ background: "transparent", boxShadow: "none" }}
          >
            <img src="/aiq-logo.svg" alt="AIQ" style={{ width: "80px", height: "80px" }} />
          </motion.div>
          <h1>Artificial Intelligence Quotient</h1>
          <p className="brand-sub">Discover your AI knowledge level</p>
        </div>

        {error && (
          <motion.div
            className="error-msg"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            {error}
          </motion.div>
        )}

        {/* Google SSO — primary and only sign-in method */}
        <motion.button
          className="btn-google"
          onClick={() => googleLogin()}
          disabled={googleLoading}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          style={{ marginTop: 8 }}
        >
          {googleLoading ? (
            <span className="btn-spinner" />
          ) : (
            <>
              <FcGoogle size={20} />
              Sign in with Google
            </>
          )}
        </motion.button>

        <p className="brand-sub" style={{ marginTop: 16, fontSize: 13, opacity: 0.7 }}>
          Use your organizational Google account to continue
        </p>
      </motion.div>
    </div>
  );
}
